import { resumenService } from '@/services/resumen.service';
import type { ResumenEvaluacionResponse } from '@/types/types';
import { useCallback, useEffect, useState } from 'react';

interface UseResumenResult {
  data: ResumenEvaluacionResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useResumen(nit: string, asesoriaId?: number): UseResumenResult {
  const [data, setData] = useState<ResumenEvaluacionResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!nit) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await resumenService.getResumen(nit, asesoriaId);
      if (response.success) {
        setData(response);
      } else {
        setError('Error al cargar el resumen');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar resumen');
    } finally {
      setIsLoading(false);
    }
  }, [nit, asesoriaId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, isLoading, error, refetch };
}
